import request from '@/utils/request'

// 客户主信息API
export const getCustomers = (params) => {
  return request({
    url: '/api/customers',
    method: 'get',
    params
  })
}

/** 下拉/筛选：仅返回启用中的客户 */
export const getActiveCustomers = (params = {}) => {
  return getCustomers({ ...params, is_active: 'true', for_select: '1' })
}

export const getCustomer = (id) => {
  return request({
    url: `/api/customers/${id}`,
    method: 'get'
  })
}

export const createCustomer = (data) => {
  return request({
    url: '/api/customers',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export const updateCustomer = (id, data) => {
  return request({
    url: `/api/customers/${id}`,
    method: 'put',
    data
  })
}

export const deleteCustomer = (id) => {
  return request({
    url: `/api/customers/${id}`,
    method: 'delete'
  })
}

export const getCustomerBillingPolicy = (customerId) => {
  return request({
    url: `/api/customers/${customerId}/billing-policy`,
    method: 'get'
  })
}

export const setCustomerLocked = (id, isLocked) => {
  return request({
    url: `/api/customers/${id}/set-locked`,
    method: 'post',
    data: { is_locked: isLocked },
    headers: { 'Content-Type': 'application/json' }
  })
}

export const toggleCustomerStatus = (id, data) => {
  return request({
    url: `/api/customers/${id}`,
    method: 'put',
    data
  })
}

// 客户地址API
export const getCustomerAddresses = (customerId) => {
  return request({
    url: `/api/customers/${customerId}/addresses`,
    method: 'get'
  })
}

export const createCustomerAddress = (customerId, data) => {
  return request({
    url: `/api/customers/${customerId}/addresses`,
    method: 'post',
    data
  })
}

export const updateCustomerAddress = (customerId, addressId, data) => {
  return request({
    url: `/api/customers/${customerId}/addresses/${addressId}`,
    method: 'put',
    data
  })
}

export const deleteCustomerAddress = (customerId, addressId) => {
  return request({
    url: `/api/customers/${customerId}/addresses/${addressId}`,
    method: 'delete'
  })
}

// 客户联系人API
export const getCustomerContacts = (customerId) => {
  return request({
    url: `/api/customers/${customerId}/contacts`,
    method: 'get'
  })
}

export const createCustomerContact = (customerId, data) => {
  return request({
    url: `/api/customers/${customerId}/contacts`,
    method: 'post',
    data
  })
}

export const updateCustomerContact = (customerId, contactId, data) => {
  return request({
    url: `/api/customers/${customerId}/contacts/${contactId}`,
    method: 'put',
    data
  })
}

export const deleteCustomerContact = (customerId, contactId) => {
  return request({
    url: `/api/customers/${customerId}/contacts/${contactId}`,
    method: 'delete'
  })
}